import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

import { TEACHER_USAGE_DATA_CARD_COLOR } from "@/reports/admin/AdminUsageReportPage/constants";
const { heading6Obj } = typographyStyles;
const {
  colors: { ui },
} = constants;

const coreBlue25 = ui.core[25];

export const getDataCardColor = (color?: string) =>
  color || TEACHER_USAGE_DATA_CARD_COLOR;
export const defaultLoadingCss: CSSObject = {
  display: "flex",
  width: "100%",
  height: "100%",
  alignItems: "center",
};

export const containerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  borderRadius: "16px",
  background: coreBlue25,
  position: "relative",
  textAlign: "center",
  minHeight: "16.125rem",
};

export const headingContainerCss: CSSObject[] = [
  {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    minWidth: "100%",
    margin: 0,
    fontWeight: "bold",
    padding: "12px",
  },
];

export const headingTextCss: CSSObject[] = [heading6Obj];

export const tooltipDialogContainerCss: CSSObject = {
  margin: "8px",
  position: "absolute",
  right: 0,
  zIndex: 1,
};

export const tooltipIconCss: CSSObject = {
  width: "16px",
};

export const defaultCardContentCss: CSSObject = {
  color: ui.neutral[700],
  display: "flex",
  flexDirection: "column",
  padding: "16px 16px 32px",
  position: "relative",
  gap: "16px",
  flex: 1,
  "& > div:last-child": {
    height: "100%",
  },
};

export const cardContentWithHeadingCss: CSSObject = {
  padding: "16px",
};

export const horizontalCardContentCss: CSSObject = {
  flexDirection: "row",
  padding: "0px 32px",
  alignItems: "center",
};

export const toolTipCss: CSSObject = {
  root: {
    zIndex: 2,
  },
};
